module.exports = __webpack_public_path__ + "assets\\img\\icons\\favicon-32x32.png?963ca284ae4e8ba3f489";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/favicon-32x32.png
// module id = 152
// module chunks = 0